/**
 * TransactionUserEvents
 * Registry of events for the Assets table + components
 */
export enum TransactionUserEvents {
    ClickAssetLink = "Transactions Table - Click Asset Link",
    ClickProtocolLink = "Transactions Table - Click Protocol Link",
    ClickNetworkLink = "Transactions Table - Click Network Link",
    ClickAssetClass = "Transactions Table - Clink Asset Class Link",
    ClickTokenAddress = "Transactions Table - Click Token Address Link",
    ClickFromAddress = "Transactions Table - From Address Link",
    ClickToAddress = "Transactions Table - To Address Link",
    ClickTransactionHash = "Transactions Table - Transaction Link",
}
